import { tgxApi } from "../../app/tgxApi";
import {
    getAuthorizationHeader,
    handleQueryError,
    handleQueryErrorAndSuccess
} from "../../helpers/utils/RtkQueryUtils";
import { openFileInNewTab } from "../../helpers/utils/FileUtils";

export const pdfSettingsApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({

        updatePdfSettings: build.mutation({
            query: ({pdfSettingObj }) => {
                return {
                    url: `/ajax/update-pdf-setting`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: pdfSettingObj
                };
            },
            invalidatesTags: ['pdfSettingsByCustomerId','pdfImageByName','customerById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            }
        }),

        updatePdfLogo: build.mutation({
            query: ({ customerId, pdfLogo }) => {
                const formData = new FormData();
                formData.append('file', pdfLogo);

                return {
                    url: `/ajax/uploadPdfLogo/${customerId}`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: formData
                };
            },
            invalidatesTags: ['pdfSettingsByCustomerId','pdfImageByName','customerById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            }
        }),

        getPdfSettingsByCustomerId: build.query({
            query: (customerId) => {
                return {
                    url: `/ajax/get-customer-pdf-setting-by-id/${customerId}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags:["pdfSettingsByCustomerId"],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            }
        }),

        getPdfImageByName: build.query({
            query: (imageName) => {
                return {
                    url: `/ajax/get-image-by-name/${imageName}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags:["pdfImageByName"],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            }
        }),

        viewPdfImage: build.query({
            query: (fileId) => {
                return {
                    url: `/pdf-settings/read-image/${fileId}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        openFileInNewTab(blob)
                        return { success: true };
                    },
                };

            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getPdfSettingsForInvoice: build.query({
            query: (customerId) => {
                return {
                    url: `/pdf-settings?customerId=${customerId}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            }
        }),

    }),
});

export const {
    useGetPdfSettingsByCustomerIdQuery,
    useGetPdfImageByNameQuery,
    useUpdatePdfSettingsMutation,
    useUpdatePdfLogoMutation
} = pdfSettingsApi;
